"use client";

/**
 * 2026-10 — 結帳「寄送地區 / 購買地區」選擇:台灣 / 香港 / 中國。
 * 貼紙結帳(app/stickers/StickersClient.js)與購物車結帳(CartDrawer)共用。
 * 樣式全用 inline style(不靠呼叫端的 styled-jsx class),兩邊放進去長得一樣。
 */
import { REGION, REGION_LABEL } from "@/lib/overseasCheckout";

const OPTIONS = [
  { value: REGION.TW, hint: "綠界付款" },
  { value: REGION.HK, hint: "轉數快 FPS" },
  { value: REGION.CN, hint: "微信支付" },
];

export default function RegionSelector({ value, onChange, name = "region" }) {
  return (
    <div
      role="radiogroup"
      aria-label="購買地區"
      className="grid grid-cols-3 gap-2"
    >
      {OPTIONS.map((opt) => {
        const active = value === opt.value;
        return (
          <button
            key={opt.value}
            type="button"
            role="radio"
            aria-checked={active}
            data-region={opt.value}
            name={name}
            onClick={() => onChange(opt.value)}
            className="flex flex-col items-center justify-center transition-colors"
            style={{
              minHeight: "52px",
              padding: "6px 4px",
              borderRadius: "10px",
              border: active
                ? "2px solid var(--color-accent)"
                : "1px solid var(--color-cardBorder)",
              backgroundColor: active
                ? "rgba(232, 160, 191, 0.14)"
                : "var(--color-bg)",
              color: "var(--color-text)",
              cursor: "pointer",
            }}
          >
            <span
              style={{
                fontSize: "15px",
                fontWeight: active ? 700 : 500,
                lineHeight: 1.2,
              }}
            >
              {REGION_LABEL[opt.value]}
            </span>
            <span
              style={{
                fontSize: "11px",
                marginTop: "2px",
                color: active
                  ? "var(--color-accent)"
                  : "var(--color-textMuted)",
              }}
            >
              {opt.hint}
            </span>
          </button>
        );
      })}
    </div>
  );
}

/**
 * 結帳提醒(製作到寄送需 14–21 天、微信支付開通中等),空字串不顯示。
 * children:放在文字下方的動作(例如「加官方 LINE」按鈕)。
 */
export function CheckoutNotice({ text, tone = "info", children }) {
  if (!text) return null;
  const warn = tone === "warn";
  // tone="note":一般說明(例如「需中國大陸實名認證的微信才能付款」),不是時程提醒
  const note = tone === "note";
  return (
    <div
      data-testid={
        warn
          ? "checkout-warn-notice"
          : note
            ? "checkout-note"
            : "checkout-lead-time-notice"
      }
      role={warn ? "alert" : undefined}
      className="text-sm"
      style={{
        margin: 0,
        padding: "10px 12px",
        borderRadius: "8px",
        lineHeight: 1.6,
        // 文字一律跟主題走(8 組主題有亮有暗),只用框線/底色區分提醒等級
        color: "var(--color-text)",
        backgroundColor: warn
          ? "rgba(245, 158, 11, 0.12)"
          : "rgba(232, 160, 191, 0.12)",
        border: warn
          ? "1px solid rgba(245, 158, 11, 0.45)"
          : "1px solid rgba(232, 160, 191, 0.35)",
      }}
    >
      <p style={{ margin: 0 }}>
        {warn ? "⚠️ " : note ? "ℹ️ " : "⏳ "}
        {text}
      </p>
      {children}
    </div>
  );
}
